import React from 'react';
import { PlatformType } from '@okletsplay/core';
import { TournamentEntity } from 'app/interfaces/entity';
import { TournamentSettingsOption } from '../interfaces';
import { MapFormat } from 'shared/components/Format/LeagueOfLegendsFormat/MapFormat';
import { PickTypeFormat } from 'shared/components/Format/LeagueOfLegendsFormat/PickTypeFormat';
import { ChessMatchTypeFormat } from 'shared/components/Format/ChessMatchTypeFormat';
import { getEvIoMatchSetupSettingsOptions } from './get-ev-io-match-setup-settings-options';
import { useSelector } from 'react-redux';
import { gamesSelectorFactory } from 'modules/games/store/games/selectors';
import { GameActivityType } from 'shared/enums';

export const useTournamentMatchSetupSettings = (
  tournament?: TournamentEntity
): TournamentSettingsOption[] => {
  const settings = tournament?.matchSetupSettings ?? {};
  const platformType = tournament?.game?.platformType;

  const game = useSelector(gamesSelectorFactory.useById(tournament?.game?.id ?? ''));

  if (!tournament || !game) return [];

  switch (platformType) {
    case PlatformType.LeagueOfLegends: {
      return [
        { label: 'region', value: settings.region },
        { label: 'map', value: <MapFormat map={settings.map} /> },
        {
          label: 'pick type',
          value: <PickTypeFormat type={settings.pickType} />,
        },
      ];
    }
    case PlatformType.Lichess: {
      return [
        {
          label: 'timer settings',
          value: (
            <ChessMatchTypeFormat limit={settings.clockLimit} increment={settings.clockIncrement} />
          ),
        },
      ];
    }
    case PlatformType.EvIo: {
      return getEvIoMatchSetupSettingsOptions(settings, game, GameActivityType.Tournament);
    }
    default:
      return [];
  }
};
